// src/hooks/useLearners.js
import { useEffect, useState } from "react";
import { message } from "antd";
import learnersService from "PlatForms/OrgLMS/Services/ManagerService/learnersService";

const useLearners = (managerId) => {
  const [learners, setLearners] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  const fetchLearners = async () => {
    setLoading(true);
    try {
      const data = await learnersService.getLearnersByManager(managerId, token);
      setLearners(data);
    } catch (error) {
      message.error("Failed to fetch learners");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (managerId) fetchLearners();
  }, [managerId]);

  return {
    learners,
    loading,
    refresh: fetchLearners,
  };
};

export default useLearners;
